/* eslint-disable */
import { HttpClient, RequestParams } from "./http-client";

export class AdminStats<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  summary = (params: RequestParams = {}) =>
    this.request<any, any>({ path: `/AdminStats/Summary`, method: "GET", secure: true, ...params });
}
